import { LocationDto } from "../locations/LocationDtos";

export enum CheckSubTypeEnum {
    Chest = 1,
    Pot = 2,
    RecoveryHeart = 3,
    SilverRupee = 4,
    PoH = 5,
    GoldenSkulltula = 6,
    Crate = 7,
    Song = 8,
    Beehive = 9,
    Rupee = 10,
    GossipStone = 11,
    Cow = 12,
    Scrub = 13,
    StandardNPC = 14,
    Overworld = 15,
    GenericGrotto = 16,
    ScrubGrotto = 17,
    CowGrotto = 18,
    FairyGrotto = 19,
    SpecialGrotto = 20,
    SimpleInterior = 21,
    SpecialInterior = 22,
    GreatFairy = 23
}
export interface CheckDto {
    id: number,
    name: string,
    tags: string,
    location: LocationDto,
    logic: string,
    checkSubType: CheckSubTypeDto
}


export interface CheckSubTypeDto {
    id: number,
    name: string,
    checkType: CheckTypeDto
}

export interface CheckTypeDto {
    id: number,
    name: string
}